import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmex = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 33,
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3885_27558)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0.71875 0.79892H32.9198V18.182L31.326 20.6724L32.9198 22.8889V33H0.71875V16.6131L1.71492 15.4675L0.71875 14.3717V0.79892Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.96973 23.2376V18.182H12.3226L12.8969 18.9307L13.4902 18.182H32.9199V22.8889C32.9199 22.8889 32.4118 23.2325 31.8241 23.2376H21.0655L20.418 22.4407V23.2376H18.2961V21.8772C18.2961 21.8772 18.0063 22.0671 17.3797 22.0671H16.6574V23.2376H13.4448L12.8713 22.4728L12.289 23.2376H6.96973Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.71875 14.3717L1.92585 11.5575H4.01339L4.69844 13.1339V11.5575H7.29345L7.70126 12.6969L8.09661 11.5575H19.7455V12.1303C19.7455 12.1303 20.3579 11.5575 21.3643 11.5575L25.144 11.5707L25.8172 13.1265V11.5575H27.9888L28.5865 12.4511V11.5575H30.7781V16.613H28.5865L28.0137 15.7165V16.613H24.8231L24.5022 15.8161H23.6445L23.3288 16.613H21.1651C20.2991 16.613 19.7455 16.0519 19.7455 16.0519V16.613H16.4831L15.8356 15.8161V16.613H3.70414L3.3835 15.8161H2.52848L2.21011 16.613H0.71875V14.3717Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.35272 12.1808L0.724609 15.9662H1.78459L2.085 15.2082H3.8314L4.13025 15.9662H5.21359L3.58703 12.1808H2.35272ZM2.95509 13.0617L3.48742 14.3863H2.42121L2.95509 13.0617Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.32617 15.9656V12.1801L6.83247 12.1857L7.70858 14.6263L8.56371 12.1801H10.058V15.9656H9.11161V13.1763L8.10845 15.9656H7.27849L6.27253 13.1763V15.9656H5.32617Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.7051 15.9656V12.1801H13.7932V13.0269H11.6614V13.6744H13.7434V14.4713H11.6614V15.1437H13.7932V15.9656H10.7051Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.3408 12.1808V15.9662H15.2872V14.6214H15.6856L16.8203 15.9662H17.9768L16.7316 14.5716C17.2427 14.5284 17.7698 14.0898 17.7698 13.4088C17.7698 12.6123 17.1446 12.1808 16.4468 12.1808H14.3408ZM15.2872 13.0275H16.369C16.6285 13.0275 16.8172 13.2305 16.8172 13.426C16.8172 13.6775 16.5726 13.8244 16.383 13.8244H15.2872V13.0275Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.1235 15.9656H18.1572V12.1801H19.1235V15.9656Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.4144 15.9656H21.2059C20.1967 15.9656 19.584 15.1705 19.584 14.0884C19.584 12.9796 20.1898 12.1801 21.4642 12.1801H22.5102V13.0767H21.426C20.9087 13.0767 20.5428 13.4804 20.5428 14.0978C20.5428 14.8309 20.9612 15.1388 21.5639 15.1388H21.8129L21.4144 15.9656Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.4728 12.1808L21.8447 15.9662H22.9047L23.2051 15.2082H24.9515L25.2504 15.9662H26.3337L24.7071 12.1808H23.4728ZM24.0752 13.0617L24.6075 14.3863H23.5413L24.0752 13.0617Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.4453 15.9656V12.1801H27.6485L29.1848 14.5585V12.1801H30.1311V15.9656H28.9669L27.3917 13.525V15.9656H26.4453Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.61719 22.5901V18.8046H10.7053V19.6514H8.57351V20.2989H10.6555V21.0958H8.57351V21.7682H10.7053V22.5901H7.61719Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.749 22.5901V18.8046H25.8371V19.6514H23.7053V20.2989H25.7774V21.0958H23.7053V21.7682H25.8371V22.5901H22.749Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.8249 22.5901L12.3285 20.7207L10.7891 18.8046H11.9813L12.8981 19.9891L13.818 18.8046H14.9636L13.4445 20.6973L14.9508 22.5901H13.7587L12.8686 21.4242L12 22.5901H10.8249Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.0635 18.8052V22.5907H16.0347V21.3953H17.0309C17.8738 21.3953 18.5127 20.9481 18.5127 20.0785C18.5127 19.3581 18.0116 18.8052 17.1539 18.8052H15.0635ZM16.0347 19.6613H17.0838C17.3561 19.6613 17.5508 19.8282 17.5508 20.0971C17.5508 20.3498 17.3571 20.533 17.0807 20.533H16.0347V19.6613Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.9229 18.8046V22.5901H19.8692V21.2452H20.2677L21.4024 22.5901H22.5589L21.3137 21.1954C21.8247 21.1523 22.3518 20.7137 22.3518 20.0327C22.3518 19.2361 21.7266 18.8046 21.0288 18.8046H18.9229ZM19.8692 19.6514H20.951C21.2105 19.6514 21.3993 19.8544 21.3993 20.0498C21.3993 20.3013 21.1547 20.4483 20.965 20.4483H19.8692V19.6514Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.2754 22.5901V21.7682H28.1694C28.4496 21.7682 28.571 21.6168 28.571 21.4507C28.571 21.2916 28.45 21.1307 28.1694 21.1307H27.3135C26.5696 21.1307 26.1553 20.6774 26.1553 19.9969C26.1553 19.39 26.5347 18.8046 27.6402 18.8046H29.4831L29.0846 19.6563H27.4908C27.1861 19.6563 27.0923 19.8162 27.0923 19.9689C27.0923 20.1258 27.2082 20.2989 27.441 20.2989H28.3375C29.1668 20.2989 29.5267 20.7693 29.5267 21.3853C29.5267 22.0476 29.1257 22.5901 28.2924 22.5901H26.2754Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.7491 22.5901V21.7682H31.643C31.9233 21.7682 32.0446 21.6168 32.0446 21.4507C32.0446 21.2916 31.9237 21.1307 31.643 21.1307H30.7872C30.0432 21.1307 29.6289 20.6774 29.6289 19.9969C29.6289 19.39 30.0083 18.8046 31.1138 18.8046H32.9567L32.5583 19.6563H30.9644C30.6597 19.6563 30.5659 19.8162 30.5659 19.9689C30.5659 20.1258 30.6818 20.2989 30.9146 20.2989H31.8111C32.6405 20.2989 33.0003 20.7693 33.0003 21.3853C33.0003 22.0476 32.5993 22.5901 31.766 22.5901H29.7491Z",
				fill: "#016FD0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3885_27558",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white",
			transform: "translate(0.867188 0.897217)"
		})
	}) })]
});
export default SvgAmex;
